module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Name *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.name),
      expression: "entity.name"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "name",
      "type": "text",
      "placeholder": "Enter name"
    },
    domProps: {
      "value": (_vm.entity.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2"
  }, [_vm._v("Permissions")]), _vm._v(" "), (_vm.defaultOptionsLoaders.permissions) ? _c('div', {
    staticClass: "col-md-10 spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  })], 1) : _c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "mb-10"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.selectAll
    }
  }, [_vm._v("Select all")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.deselectAll
    }
  }, [_vm._v("Deselect all")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "column-count": "3"
    }
  }, _vm._l((_vm.defaultOptions.permissions), function(permission) {
    return _c('div', {
      key: permission.id
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.entity.permissions),
        expression: "entity.permissions"
      }],
      attrs: {
        "id": permission.id,
        "type": "checkbox"
      },
      domProps: {
        "value": permission,
        "checked": Array.isArray(_vm.entity.permissions) ? _vm._i(_vm.entity.permissions, permission) > -1 : (_vm.entity.permissions)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.entity.permissions,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = permission,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.entity, "permissions", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.entity, "permissions", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.entity, "permissions", $$c)
          }
        }
      }
    }), _vm._v(" " + _vm._s(permission.name) + "\n                      ")])])
  }), 0)])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Role has created successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("Create Role ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("General")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fc3096d4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/roles/New.vue
// module id = 1006
// module chunks = 0